import {
  createGlobalStyle,
  styled,
} from '@acko-tech/building-blocks.ui.common';
import { INTERNATIONAL_DESKTOP_ASSETS } from '../utils/config';

export const GlobalStyle: any = createGlobalStyle`
    body {
        color: #040222;
    }
    scroll-behavior: auto;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  align-items: center;
  margin-top: 10px;
`;

export const CheckboxText = styled.div`
  font-weight: 500;
  font-size: 0.8rem;
  color: #434f5a;
  margin-left: 10px;
  margin-top: 2px;
`;

export const PageLoader = styled.img`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
  width: 100px;
`;

export const ErrorMessage = styled.div`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  color: #5b5675;
`;

export const Container = styled.div`
  width: 100%;
  max-width: ${(props) => props.maxWidth};
  margin: ${(props) => props.margin || 'auto'};
  padding: ${(props) => props.padding || '0'};
  box-shadow: ${(props) =>
    !props.noShadow ? '0px 10px 20px rgb(0,0,0,0.2)' : ''};
`;

export const FlexContainer = styled.div`
  width: ${(props) => props.width || '100%'};
  display: flex;
  flex-direction: ${(props) => props.direction || 'column'};
  align-items: ${(props) => props.align || 'center'};
  justify-content: ${(props) => props.justify || 'flex-start'};
  position: ${(props) => props.position || 'relative'};
  height: ${(props) => props.height || 'initial'};
  gap: ${(props) => props.gap || '10px'};
  padding: ${(props) => props.padding || 'initial'};
  background: white;
  max-width: inherit;
  ${(props) => props && props.styles};
`;

export const SectionTitle = styled.div`
  width: 100%;
  font-weight: ${(props) => props.weight || '600'};
  font-size: ${(props) => props.size || '1.4rem'};
  line-height: ${(props) => props.lineHeight || '2rem'};
  margin-top: ${(props) => props.marginTop || '0px'};
  margin-bottom: ${(props) => props.marginBottom || '24px'};
  padding-left: ${(props) => props.left || '0'};
  text-align: ${(props) => props.align};
`;

export const StickyCTA = styled.div`
  cursor: pointer;
  width: 100%;
  position: absolute;
  bottom: 0px;
`;

export const ButtonContainer = styled.div`
  margin-left: ${(props) => props.marginLeft || ''};
  margin-top: ${(props) => props.marginTop || '10px'};
  width: ${(props) => props.width || 'inherit'};
  position: ${(props) => props.position || 'relative'};
  cursor: pointer;
  bottom: ${(props) => props.bottom || 'unset'};
  ${(props) => props && props.styles};
`;

export const ButtonLoaderImage = styled.img`
  display: ${(props) => (props.visibility ? 'block' : 'none')};
  width: 65px;
  position: absolute;
  left: 50%;
  margin-top: ${(props) => props.marginTop || '30px'};
  transform: translateX(-50%);
`;

export const ButtonText = styled.div`
  visibility: ${(props) => (props.hide ? 'hidden' : 'unset')};
`;

export const Content = styled.div`
  position: relative;
  margin-top: 60px;
  width: 100%;
  padding: 20px;
  padding-bottom: 120px;
  color: #040222;
  max-width: inherit;
  max-width: ${(props) => props.maxWidth || '480px'};

  @media screen and (min-width: 768px) {
    background: url(${INTERNATIONAL_DESKTOP_ASSETS.JOURNEY_BACKGROUND});
    background-repeat: no-repeat;
    background-size: 100%;
    background-color: #f8fdff;
    max-width: unset;
  }
`;

export const ImageContainer = styled.div`
  cursor: pointer;
  min-width: ${(props) => props.width || 'initial'};
  max-width: ${(props) => props.width || 'initial'};
  margin: ${(props) => props.margin};
  ${(props) => props && props.styles};
  position: ${(props) => props.position || 'initial'};
`;

export const Circle = styled.div`
  height: ${(props) => props.height || '40px'};
  width: ${(props) => props.width || '40px'};
  border-radius: 50%;
  border: ${(props) => props.border || '1px solid #E0E0E8'};
  position: absolute;
  top: -18px;
  left: -2px;
`;

export const StickyText = styled.div`
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1rem;
  color: #5b5675;
  text-align: center;
  margin: 5px 0 20px 0;
`;

export const Row = styled.div`
  display: flex;
  align-items: ${(props) => props?.align || 'flex-start'};
  justify-content: ${(props) => props?.justify || 'flex-start'};
  padding-bottom: ${(props) => props?.paddingBottom || '12px'};
  margin: ${(props) => props?.margin || '0'};
  gap: ${(props) => props?.gap || '16px'};
  position: relative;
  border-bottom: ${(props) => props?.border || 'unset'};
  padding-right: ${(props) => props?.paddingRight || '20px'};
  flex-wrap: wrap;
`;

export const Accordion = styled.div`
  padding: ${(props) => props?.padding};
`;

export const AccordionItem = styled.div`
  border-bottom: 1px solid #e7e7f0;
  padding: ${(props) => props?.padding || '0 0 20px 0'};
  margin: ${(props) => props?.margin || '0 0 20px 0'};

  &:last-child {
    border: unset;
  }
`;

export const AccordionDropdown = styled.div`
  position: absolute;
  right: 0;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.375rem;
  transition: all 0.3s ease-in;
  transform: ${(props) => (props?.rotate ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const AccordionContent = styled.div`
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1rem;
  color: #5b5675;
  margin: ${(props) => props?.margin || '0 0 0 34px'};
  height: ${(props) => (!props?.open ? '0' : 'unset')};
  opacity: ${(props) => (props?.open ? '1' : '0')};
  padding: ${(props) => props?.padding};
  overflow: ${(props) => props?.overflow || 'hidden'};
  transition: all 0.25s ease-in;
`;

export const MediumText = styled.div`
  font-weight: ${(props) => props?.weight || '500'};
  font-size: ${(props) => props?.size || '0.875rem'};
  line-height: 1.25rem;
  color: ${(props) => props?.color || 'inherit'};
  max-width: ${(props) => props?.maxWidth || 'unset'};
  cursor: pointer;
`;

export const TextArea = styled.textarea`
  width: 100%;
  height: 120px;
  overflow: auto;
  padding: 12px 16px;
  border: 1px solid #e0e0e8;
  border-radius: 8px;
  font-family: inherit;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-top: 18px;
  resize: none;

  &:focus {
    outline: none;
    border: 1px solid #5b5675;
  }
`;

export const Text = styled.div`
  font-weight: ${(props) => props?.weight};
  font-size: ${(props) => props?.size};
  line-height: ${(props) => props?.lineHeight};
  color: ${(props) => props?.color};
  ${(props) => props && props.styles};
}`;

export const PhoneInputContainer = styled.div`
  position: relative;
  margin-bottom: 24px;
  width: 100%;
  ${(props) => props && props.styles};
`;

export const PostScript = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 12px;
  font-weight: ${(props) => props?.weight || '400'};
  font-size: ${(props) => props?.size || '0.75rem'};
  line-height: ${(props) => props?.lineHeight || '1rem'};
  color: ${(props) => props?.color || 'rgb(91, 86, 117)'};
  ${(props) => props && props.styles};
}`;
